// extracted by mini-css-extract-plugin
module.exports = {"body":"SeoFooterContent_body__Jl_cD","benefits":"SeoFooterContent_benefits__UDYWD","postBody":"SeoFooterContent_postBody__LNXIa"};